import React, { Fragment, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ResponsiveImage from 'components/ResponsiveImage';
import EmbeddedVideo from 'components/EmbeddedVideo';
import Modal, { modalType } from 'components/Modal';
import { breakpoints } from 'js/breakpoints';
import {
  getFullWidthImageSourcesMobile,
  getFullWidthImageSourcesDesktop,
} from 'js/image-sources';
import * as css from './TopMediaBlock.scss';

const TopMediaBlock = ({ image, videoUrl, imageCaption }) => {
  const [modalOpened, setModalOpened] = useState(false);
  const bannerContainerRef = useRef();

  const openModal = () => {
    setModalOpened(true);
  };

  const closeModal = () => {
    setModalOpened(false);
  };

  return (
    <div className={css.topMediaBlock} ref={bannerContainerRef}>
      <div className={css.topMediaBlockHolder}>
        {videoUrl && (
          <Fragment>
            <button
              className={css.topMediaBlockBtn}
              onClick={openModal}
            ></button>
            {modalOpened && (
              <Modal onClose={closeModal} type={modalType.video}>
                <EmbeddedVideo videoUrl={videoUrl} />
              </Modal>
            )}
          </Fragment>
        )}
        {image && (
          <Fragment>
            <meta itemProp="image" content={image.src} />
            <ResponsiveImage
              {...image}
              fluid
              fetchPriority="high"
              sources={[
                ...getFullWidthImageSourcesMobile(450, 767),
                ...getFullWidthImageSourcesDesktop(450, 767, 1024),
                {
                  width: 1440,
                  height: 450,
                  media: breakpoints.xl,
                },
              ]}
            />
          </Fragment>
        )}
      </div>
      {imageCaption && (
        <span className={css.bannerImageCaption}>{imageCaption}</span>
      )}
    </div>
  );
};

TopMediaBlock.propTypes = {
  image: PropTypes.exact(ResponsiveImage.propTypes),
  videoUrl: PropTypes.string,
  imageCaption: PropTypes.string,
};

export default TopMediaBlock;
